import styled from "styled-components";

export const LoginPageWrapper = styled.div`
  height: 100vh;
  width: 100vw;
  display: flex;
  background: var(--sp-bg-deep, #ffffff);
  color: var(--sp-ink, #0f172a);
  overflow: hidden;
  color-scheme: light;

  html.dark &,
  body.app-dark-theme & {
    color-scheme: dark;
  }

  .login-container {
    display: flex;
    width: 100%;
    height: 100%;
    background: var(--sp-bg-deep, #ffffff);
  }

  .left-panel {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 40px;
    background: var(--sp-bg-card, #ffffff);
  }

  .form-wrapper {
    width: 100%;
    max-width: 400px;
  }

  .logo-section {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 32px;
  }

  .logo-image {
    height: 80px;
    width: auto;
    object-fit: contain;
  }

  .welcome-text {
    font-size: 14px;
    color: var(--sp-ink-3, #999);
    margin: 0 0 8px 0;
  }

  .form-title {
    font-size: 28px;
    font-weight: 700;
    color: var(--sp-ink, #333);
    margin: 0 0 32px 0;
  }

  .error-box {
    background: var(--sp-error-bg, #ffebee);
    color: var(--sp-error, #c62828);
    padding: 12px;
    border-radius: 8px;
    text-align: center;
    font-size: 14px;
    margin-bottom: 20px;
  }

  .success-box {
    background: var(--sp-success-lt, #e8f5e9);
    color: var(--sp-success, #2e7d32);
    padding: 12px;
    border-radius: 8px;
    text-align: center;
    font-size: 14px;
    margin-bottom: 20px;
  }

  .login-form {
    display: flex;
    flex-direction: column;
    gap: 24px;
    margin-bottom: 24px;
  }

  .input-group {
    display: flex;
    flex-direction: column;
    gap: 8px;
  }

  .input-label {
    font-size: 14px;
    font-weight: 500;
    color: var(--sp-ink, #333);
  }

  .phone-input-wrapper {
    display: flex;
    gap: 0;
    border: 1px solid var(--sp-border-md, #e0e0e0);
    border-radius: 8px;
    overflow: hidden;
    background: var(--sp-bg-card, #ffffff);
  }

  .country-code-selector {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 12px 14px;
    background: var(--sp-bg-surface, #f5f5f5);
    border-right: 1px solid var(--sp-border-md, #e0e0e0);
    cursor: default;
    transition: background 0.3s ease;
    min-width: 90px;
  }

  .country-code-selector:hover {
    background: var(--sp-bg-surface, #e8e8e8);
  }

  .country-code {
    font-size: 14px;
    font-weight: 500;
    color: var(--sp-ink, #333) !important;
  }

  .dropdown-icon {
    font-size: 10px;
    color: var(--sp-ink-3, #666);
  }

  .input-field {
    width: 100%;
    padding: 12px 14px;
    border: 1px solid var(--sp-border-md, #e0e0e0);
    border-radius: 8px;
    font-size: 16px;
    outline: none;
    transition: border-color 0.3s ease;
    background: var(--sp-bg-card, #ffffff);
    color: var(--sp-ink, #0f172a);
    caret-color: var(--sp-ink, #0f172a);

    &::placeholder {
      color: var(--sp-ink-3, #94a3b8);
      opacity: 1;
    }

    &:-webkit-autofill,
    &:-webkit-autofill:hover,
    &:-webkit-autofill:focus,
    &:-webkit-autofill:active {
      -webkit-box-shadow: 0 0 0 1000px var(--sp-bg-card, #ffffff) inset !important;
      box-shadow: 0 0 0 1000px var(--sp-bg-card, #ffffff) inset !important;
      -webkit-text-fill-color: var(--sp-ink, #0f172a) !important;
      caret-color: var(--sp-ink, #0f172a);
    }

    &:focus {
      border-color: var(--sp-trust, #1976d2);
    }
  }

  .phone-input {
    flex: 1;
    border: none;
    border-radius: 0;
    padding: 12px 14px;
    background: transparent;
    color: var(--sp-ink, #0f172a);
    caret-color: var(--sp-ink, #0f172a);
  }

  .phone-input:focus {
    border: none;
    outline: none;
  }

  .phone-input-wrapper:focus-within {
    border-color: var(--sp-trust, #1976d2);
  }

  .phone-input:disabled {
    background: var(--sp-bg-surface, #f5f5f5);
    cursor: not-allowed;
  }

  .otp-input {
    text-align: center;
    font-size: 20px;
    font-weight: 600;
    letter-spacing: 4px;
    padding: 14px;
  }

  .otp-actions {
    display: flex;
    justify-content: center;
    margin-top: -16px;
  }

  .change-number-link {
    font-size: 14px;
    color: var(--sp-trust, #1976d2);
    cursor: pointer;
    text-decoration: none;
    transition: color 0.3s ease;
  }

  .change-number-link:hover {
    text-decoration: underline;
    color: var(--sp-trust, #1565c0);
  }

  .forgot-password-link {
    font-size: 14px;
    color: var(--sp-trust, #1976d2);
    text-align: right;
    cursor: pointer;
    text-decoration: none;
    margin-top: -12px;
  }

  .forgot-password-link:hover {
    text-decoration: underline;
    color: var(--sp-trust, #1565c0);
  }

  .login-btn {
    width: 100%;
    padding: 14px 24px;
    background: var(--sp-trust, #1976d2);
    color: #ffffff;
    border: none;
    border-radius: 8px;
    font-size: 16px;
    font-weight: 600;
    cursor: pointer;
    transition: background 0.3s ease;
  }

  .login-btn:hover:not(:disabled) {
    filter: brightness(0.95);
  }

  .login-btn:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }

  .signup-link-section {
    text-align: center;
    margin-bottom: 12px;
  }

  .signup-text {
    font-size: 14px;
    color: var(--sp-ink-3, #666);
  }

  .signup-link {
    font-size: 14px;
    color: var(--sp-trust, #1976d2);
    font-weight: 500;
    cursor: pointer;
    text-decoration: none;
  }

  .signup-link:hover {
    text-decoration: underline;
  }

  .alt-login-link-section {
    text-align: center;
  }

  .alt-login-text {
    font-size: 14px;
    color: var(--sp-ink-3, #666);
  }

  .alt-login-link {
    font-size: 14px;
    color: var(--sp-trust, #1976d2);
    font-weight: 500;
    cursor: pointer;
    text-decoration: none;
  }

  .alt-login-link:hover {
    text-decoration: underline;
  }

  .right-panel {
    flex: 1;
    position: relative;
    overflow: hidden;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .promo-image-full {
    width: calc(100% - 40px);
    height: calc(100% - 80px);
    object-fit: cover;
    margin-top: 40px;
    margin-right: 40px;
    margin-bottom: 40px;
    border-radius: 12px;
  }

  @media (max-width: 968px) {
    .login-container {
      flex-direction: column;
      height: auto;
      max-height: none;
    }

    .left-panel {
      flex: 1;
      padding: 30px 20px;
    }

    .right-panel {
      flex: 1;
      padding: 30px 20px;
      min-height: 400px;
    }
  }

  @media (max-width: 640px) {
    .form-title {
      font-size: 24px;
    }
  }
`;
